import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import { FAQWording } from 'constants/faq'
import { AnimatePresence, motion } from 'motion/react'
import { useSurveyStore } from 'store'

// Custom components
import CustomDisclosure from 'components/Disclosure'
import PageWrapper from 'components/PageWrapper'
import Card from 'components/Card'
import PrimaryButton from 'components/primaryButton'

// Assets
import handsUp from 'assets/images/emojis/hands-up.png'

const FAQ = () => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_faq' })
  }, [])

  return (
    <PageWrapper
      viewSelected='/centro-de-ayuda'
      className='!px-0 md:px-4'
      title='Preguntas frecuentes'
      noTabBar
    >
      <section className='px-4 mt-4 space-y-4 text-black md:flex md:max-w-564 md:flex-col mb-20 md:mb-5 mx-auto'>
        {FAQWording.map((item) => (
          <CustomDisclosure
            ans={item.answer}
            qn={item.question}
            id={item.id.toString()}
          />
        ))}
        <Survey />
      </section>
    </PageWrapper>
  )
}

export default FAQ

const Survey = () => {
  const { isAnswered, updateSurveyIsAnswered } = useSurveyStore()

  return (
    <AnimatePresence initial={false}>
      {isAnswered ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          layout
        >
          <Card className='bg-survey-bg p-4 flex justify-between gap-2 items-center'>
            <div className='font-bold text-xs'>
              <p className=' text-purple-900'>¡Muchas gracias!</p>
              <p className='text-blue-900 text-2xs mt-3'>
                Tu opinión nos ayuda a mejorar la información para todas las
                personas.
              </p>
            </div>
            <img src={handsUp} className='w-10 h-full shrink-0' alt='🙌' />
          </Card>
        </motion.div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          layout
        >
          <Card className='bg-white p-4'>
            <p className='font-bold text-xs text-gray-900'>
              ¿Encontraste la información que buscabas?
            </p>
            <div className='flex gap-2 mt-4'>
              <PrimaryButton
                className='h-9'
                outlined
                buttonText='No'
                primaryButtonFunction={() => {
                  trackEvent({ eventName: 'bille_faq_boton_encuesta_no' })
                  updateSurveyIsAnswered(true)
                }}
              />
              <PrimaryButton
                className='h-9'
                buttonText='Sí'
                primaryButtonFunction={() => {
                  trackEvent({ eventName: 'bille_faq_boton_encuesta_si' })
                  updateSurveyIsAnswered(true)
                }}
              />
            </div>
          </Card>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
